import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const useOrder = (order) => {
  const t = useTranslations('common');
  const billing_address = useMemo(() => {
    if (!order?.billing_address) return null;
    return {
      ...order.billing_address,
      telephone: order.billing_address.telephone?.slice(-12),
    };
  }, [order?.billing_address]);
  const items = order?.items || [];
  const ordered_items_count =
    items.reduce((total, item) => total + (item?.qty_ordered || 0), 0) ||
    items?.length;

  const payment_method = order?.payment?.method;

  const {
    subtotal_incl_tax = 0,
    discount_amount = 0,
    base_shipping_amount = 0,
    base_tax_amount = 0,
    grand_total = 0,
  } = order || {};
  // Prepare TotalSegments
  const TotalSegments = useMemo(
    () => [
      {
        code: 'subtotal',
        is_available: true,
        title: t('subtotal_key'),
        value: subtotal_incl_tax,
      },
      {
        code: 'shipping',
        is_available: true,
        title: t('shipping_key'),
        value: base_shipping_amount,
      },
      {
        code: 'discount',
        is_available: true,
        title: t('discount_key'),
        value: discount_amount,
      },
      {
        code: 'tax',
        extension_attributes: {
          tax_grandtotal_details: [
            {
              amount: base_tax_amount,
              group_id: 1,
              is_available: true,
              rates: [
                {
                  is_available: true,
                  percent: '15',
                  title: t('VAT'),
                },
              ],
            },
          ],
        },
        is_available: true,
        title: t('tax_key'),
        value: base_tax_amount,
      },
      {
        area: 'footer',
        code: 'grand_total',
        is_available: true,
        title: t('grand_total'),
        value: grand_total,
      },
    ],
    [
      subtotal_incl_tax,
      discount_amount,
      base_shipping_amount,
      base_tax_amount,
      grand_total,
      t,
    ]
  );
  // Memoize totals for performance
  const totals = useMemo(() => {
    if (Array.isArray(TotalSegments)) {
      const footerIndex = TotalSegments.findIndex(
        (item) => item?.area === 'footer'
      );
      const totalsData = TotalSegments.filter(
        (item) => item?.area !== 'footer'
      );
      return [totalsData, TotalSegments[footerIndex]];
    }
    return [];
  }, [TotalSegments]);
  // Return computed order details
  return {
    items,
    ordered_items_count,
    totals,
    billing_address,
    payment_method,
  };
};

export default useOrder;
